const sets = {
  setA:
        [
          {
            word: 'cry',
            translation: 'плакать',
            image: './src/assets/img/action(setA)/cry.jpg',
            audioSrc: './src/assets/audio/action(setA)/cry.mp3',
            category: 'Action (set A)',
          },
          {
            word: 'dance',
            translation: 'танцевать',
            image: './src/assets/img/action(setA)/dance.jpg',
            audioSrc: './src/assets/audio/action(setA)/dance.mp3',
            category: 'Action (set A)',
          },
          {
            word: 'dive',
            translation: 'нырять',
            image: './src/assets/img/action(setA)/dive.jpg',
            audioSrc: './src/assets/audio/action(setA)/dive.mp3',
            category: 'Action (set A)',
          },
          {
            word: 'draw',
            translation: 'рисовать',
            image: './src/assets/img/action(setA)/draw.jpg',
            audioSrc: './src/assets/audio/action(setA)/draw.mp3',
            category: 'Action (set A)',
          },
          {
            word: 'fish',
            translation: 'ловить рыбу',
            image: './src/assets/img/action(setA)/fish.jpg',
            audioSrc: './src/assets/audio/action(setA)/fish.mp3',
            category: 'Action (set A)',
          },
          {
            word: 'fly',
            translation: 'летать',
            image: './src/assets/img/action(setA)/fly.jpg',
            audioSrc: './src/assets/audio/action(setA)/fly.mp3',
            category: 'Action (set A)',
          },
          {
            word: 'hug',
            translation: 'обнимать',
            image: './src/assets/img/action(setA)/hug.jpg',
            audioSrc: './src/assets/audio/action(setA)/hug.mp3',
            category: 'Action (set A)',
          },
          {
            word: 'jump',
            translation: 'прыгать',
            image: './src/assets/img/action(setA)/jump.jpg',
            audioSrc: './src/assets/audio/action(setA)/jump.mp3',
            category: 'Action (set A)',
          },
        ],
  setB:
        [
          {
            word: 'open',
            translation: 'открывать',
            image: './src/assets/img/action(setB)/open.jpg',
            audioSrc: './src/assets/audio/action(setB)/open.mp3',
            category: 'Action (set B)',
          },
          {
            word: 'play',
            translation: 'играть',
            image: './src/assets/img/action(setB)/play.jpg',
            audioSrc: './src/assets/audio/action(setB)/play.mp3',
            category: 'Action (set B)',
          },
          {
            word: 'point',
            translation: 'указывать',
            image: './src/assets/img/action(setB)/point.jpg',
            audioSrc: './src/assets/audio/action(setB)/point.mp3',
            category: 'Action (set B)',
          },
          {
            word: 'ride',
            translation: 'ездить',
            image: './src/assets/img/action(setB)/ride.jpg',
            audioSrc: './src/assets/audio/action(setB)/ride.mp3',
            category: 'Action (set B)',
          },
          {
            word: 'run',
            translation: 'бегать',
            image: './src/assets/img/action(setB)/run.jpg',
            audioSrc: './src/assets/audio/action(setB)/run.mp3',
            category: 'Action (set B)',
          },
          {
            word: 'sing',
            translation: 'петь',
            image: './src/assets/img/action(setB)/sing.jpg',
            audioSrc: './src/assets/audio/action(setB)/sing.mp3',
            category: 'Action (set B)',
          },
          {
            word: 'skip',
            translation: 'пропускать, прыгать',
            image: './src/assets/img/action(setB)/skip.jpg',
            audioSrc: './src/assets/audio/action(setB)/skip.mp3',
            category: 'Action (set B)',
          },
          {
            word: 'swim',
            translation: 'плавать',
            image: './src/assets/img/action(setB)/swim.jpg',
            audioSrc: './src/assets/audio/action(setB)/swim.mp3',
            category: 'Action (set B)',
          },
        ],
  setC:
        [
          {
            word: 'argue',
            translation: 'спорить',
            image: './src/assets/img/action(setC)/argued.jpg',
            audioSrc: './src/assets/audio/action(setC)/argue.mp3',
            category: 'Action (set C)',
          },
          {
            word: 'build',
            translation: 'строить',
            image: './src/assets/img/action(setC)/build.jpg',
            audioSrc: './src/assets/audio/action(setC)/build.mp3',
            category: 'Action (set C)',
          },
          {
            word: 'carry',
            translation: 'нести',
            image: './src/assets/img/action(setC)/carry.jpg',
            audioSrc: './src/assets/audio/action(setC)/carry.mp3',
            category: 'Action (set C)',
          },
          {
            word: 'catch',
            translation: 'ловить',
            image: './src/assets/img/action(setC)/catch.jpg',
            audioSrc: './src/assets/audio/action(setC)/catch.mp3',
            category: 'Action (set C)',
          },
          {
            word: 'drive',
            translation: 'водить машину',
            image: './src/assets/img/action(setC)/drive.jpg',
            audioSrc: './src/assets/audio/action(setC)/drive.mp3',
            category: 'Action (set C)',
          },
          {
            word: 'drop',
            translation: 'падать',
            image: './src/assets/img/action(setC)/drop.jpg',
            audioSrc: './src/assets/audio/action(setC)/drop.mp3',
            category: 'Action (set C)',
          },
          {
            word: 'push',
            translation: 'толкать',
            image: './src/assets/img/action(setC)/push.jpg',
            audioSrc: './src/assets/audio/action(setC)/push.mp3',
            category: 'Action (set C)',
          },
          {
            word: 'pull',
            translation: 'тянуть',
            image: './src/assets/img/action(setC)/pull.jpg',
            audioSrc: './src/assets/audio/action(setC)/pull.mp3',
            category: 'Action (set C)',
          },
        ],
  adjective:
        [
          {
            word: 'big',
            translation: 'большой',
            image: './src/assets/img/Adjective/big.jpg',
            audioSrc: './src/assets/audio/Adjective/big.mp3',
            category: 'Adjective',
          },
          {
            word: 'small',
            translation: 'маленький',
            image: './src/assets/img/Adjective/small.jpg',
            audioSrc: './src/assets/audio/Adjective/small.mp3',
            category: 'Adjective',
          },
          {
            word: 'fast',
            translation: 'быстрый',
            image: './src/assets/img/Adjective/fast.jpg',
            audioSrc: './src/assets/audio/Adjective/fast.mp3',
            category: 'Adjective',
          },
          {
            word: 'slow',
            translation: 'медленный',
            image: './src/assets/img/Adjective/slow.jpg',
            audioSrc: './src/assets/audio/Adjective/slow.mp3',
            category: 'Adjective',
          },
          {
            word: 'friendly',
            translation: 'дружелюбный',
            image: './src/assets/img/Adjective/friendly.jpg',
            audioSrc: './src/assets/audio/Adjective/friendly.mp3',
            category: 'Adjective',
          },
          {
            word: 'unfriendly',
            translation: 'недружелюбный',
            image: './src/assets/img/Adjective/unfriendly.jpg',
            audioSrc: './src/assets/audio/Adjective/unfriendly.mp3',
            category: 'Adjective',
          },
          {
            word: 'young',
            translation: 'молодой',
            image: './src/assets/img/Adjective/young.jpg',
            audioSrc: './src/assets/audio/Adjective/young.mp3',
            category: 'Adjective',
          },
          {
            word: 'old',
            translation: 'старый',
            image: './src/assets/img/Adjective/old.jpg',
            audioSrc: './src/assets/audio/Adjective/old.mp3',
            category: 'Adjective',
          },
        ],
  setD:
        [
          {
            word: 'cat',
            translation: 'кот',
            image: './src/assets/img/Animal(setA)/cat.jpg',
            audioSrc: './src/assets/audio/Animal(setA)/cat.mp3',
            category: 'Animal (set A)',
          },
          {
            word: 'chick',
            translation: 'цыплёнок',
            image: './src/assets/img/Animal(setA)/chick.jpg',
            audioSrc: './src/assets/audio/Animal(setA)/chick.mp3',
            category: 'Animal (set A)',
          },
          {
            word: 'chicken',
            translation: 'курица',
            image: './src/assets/img/Animal(setA)/chicken.jpg',
            audioSrc: './src/assets/audio/Animal(setA)/chicken.mp3',
            category: 'Animal (set A)',
          },
          {
            word: 'dog',
            translation: 'собака',
            image: './src/assets/img/Animal(setA)/dog.jpg',
            audioSrc: './src/assets/audio/Animal(setA)/dog.mp3',
            category: 'Animal (set A)',
          },
          {
            word: 'horse',
            translation: 'лошадь',
            image: './src/assets/img/Animal(setA)/horse.jpg',
            audioSrc: './src/assets/audio/Animal(setA)/horse.mp3',
            category: 'Animal (set A)',
          },
          {
            word: 'pig',
            translation: 'свинья',
            image: './src/assets/img/Animal(setA)/pig.jpg',
            audioSrc: './src/assets/audio/Animal(setA)/pig.mp3',
            category: 'Animal (set A)',
          },
          {
            word: 'rabbit',
            translation: 'кролик',
            image: './src/assets/img/Animal(setA)/rabbit.jpg',
            audioSrc: './src/assets/audio/Animal(setA)/rabbit.mp3',
            category: 'Animal (set A)',
          },
          {
            word: 'sheep',
            translation: 'овца',
            image: './src/assets/img/Animal(setA)/sheep.jpg',
            audioSrc: './src/assets/audio/Animal(setA)/sheep.mp3',
            category: 'Animal (set A)',
          },
        ],
  setI:
        [
          {
            word: 'bird',
            translation: 'птица',
            image: './src/assets/img/Animal(setB)/bird.jpg',
            audioSrc: './src/assets/audio/Animal(setB)/bird.mp3',
            category: 'Animal (set B)',
          },
          {
            word: 'fish',
            translation: 'рыба',
            image: './src/assets/img/Animal(setB)/fish1.jpg',
            audioSrc: './src/assets/audio/Animal(setB)/fish.mp3',
            category: 'Animal (set B)',
          },
          {
            word: 'frog',
            translation: 'жаба',
            image: './src/assets/img/Animal(setB)/frog.jpg',
            audioSrc: './src/assets/audio/Animal(setB)/frog.mp3',
            category: 'Animal (set B)',
          },
          {
            word: 'giraffe',
            translation: 'жираф',
            image: './src/assets/img/Animal(setB)/giraffe.jpg',
            audioSrc: './src/assets/audio/Animal(setB)/giraffe.mp3',
            category: 'Animal (set B)',
          },
          {
            word: 'lion',
            translation: 'лев',
            image: './src/assets/img/Animal(setB)/lion.jpg',
            audioSrc: './src/assets/audio/Animal(setB)/lion.mp3',
            category: 'Animal (set B)',
          },
          {
            word: 'mouse',
            translation: 'мышь',
            image: './src/assets/img/Animal(setB)/mouse.jpg',
            audioSrc: './src/assets/audio/Animal(setB)/mouse.mp3',
            category: 'Animal (set B)',
          },
          {
            word: 'turtle',
            translation: 'черепаха',
            image: './src/assets/img/Animal(setB)/turtle.jpg',
            audioSrc: './src/assets/audio/Animal(setB)/turtle.mp3',
            category: 'Animal (set B)',
          },
          {
            word: 'dolphin',
            translation: 'дельфин',
            image: './src/assets/img/Animal(setB)/dolphin.jpg',
            audioSrc: './src/assets/audio/Animal(setB)/dolphin.mp3',
            category: 'Animal (set B)',
          },
        ],
  clothes:
        [
          {
            word: 'skirt',
            translation: 'юбка',
            image: './src/assets/img/Clothes/skirt.jpg',
            audioSrc: './src/assets/audio/Clothes/skirt.mp3',
            category: 'Clothes',
          },
          {
            word: 'pants',
            translation: 'брюки',
            image: './src/assets/img/Clothes/pants.jpg',
            audioSrc: './src/assets/audio/Clothes/pants.mp3',
            category: 'Clothes',
          },
          {
            word: 'blouse',
            translation: 'блузка',
            image: './src/assets/img/Clothes/blouse.jpg',
            audioSrc: './src/assets/audio/Clothes/blouse.mp3',
            category: 'Clothes',
          },
          {
            word: 'dress',
            translation: 'платье',
            image: './src/assets/img/Clothes/dress.jpg',
            audioSrc: './src/assets/audio/Clothes/dress.mp3',
            category: 'Clothes',
          },
          {
            word: 'boot',
            translation: 'ботинок',
            image: './src/assets/img/Clothes/boot.jpg',
            audioSrc: './src/assets/audio/Clothes/boot.mp3',
            category: 'Clothes',
          },
          {
            word: 'shirt',
            translation: 'рубашка',
            image: './src/assets/img/Clothes/shirt.jpg',
            audioSrc: './src/assets/audio/Clothes/shirt.mp3',
            category: 'Clothes',
          },
          {
            word: 'coat',
            translation: 'пальто',
            image: './src/assets/img/Clothes/coat.jpg',
            audioSrc: './src/assets/audio/Clothes/coat.mp3',
            category: 'Clothes',
          },
          {
            word: 'shoe',
            translation: 'туфли',
            image: './src/assets/img/Clothes/shoe.jpg',
            audioSrc: './src/assets/audio/Clothes/shoe.mp3',
            category: 'Clothes',
          },
        ],
  emotion:
        [
          {
            word: 'sad',
            translation: 'грустный',
            image: './src/assets/img/Emotion/sad.jpg',
            audioSrc: './src/assets/audio/Emotion/sad.mp3',
            category: 'Emotion',
          },
          {
            word: 'angry',
            translation: 'сердитый',
            image: './src/assets/img/Emotion/angry.jpg',
            audioSrc: './src/assets/audio/Emotion/angry.mp3',
            category: 'Emotion',
          },
          {
            word: 'happy',
            translation: 'счастливый',
            image: './src/assets/img/Emotion/happy.jpg',
            audioSrc: './src/assets/audio/Emotion/happy.mp3',
            category: 'Emotion',
          },
          {
            word: 'tired',
            translation: 'уставший',
            image: './src/assets/img/Emotion/tired.jpg',
            audioSrc: './src/assets/audio/Emotion/tired.mp3',
            category: 'Emotion',
          },
          {
            word: 'surprised',
            translation: 'удивлённый',
            image: './src/assets/img/Emotion/surprised.jpg',
            audioSrc: './src/assets/audio/Emotion/surprised.mp3',
            category: 'Emotion',
          },
          {
            word: 'scared',
            translation: 'испуганный',
            image: './src/assets/img/Emotion/scared.jpg',
            audioSrc: './src/assets/audio/Emotion/scared.mp3',
            category: 'Emotion',
          },
          {
            word: 'smile',
            translation: 'улыбка',
            image: './src/assets/img/Emotion/smile.jpg',
            audioSrc: './src/assets/audio/Emotion/smile.mp3',
            category: 'Emotion',
          },
          {
            word: 'laugh',
            translation: 'смех',
            image: './src/assets/img/Emotion/laugh.jpg',
            audioSrc: './src/assets/audio/Emotion/laugh.mp3',
            category: 'Emotion',
          },
        ],

  success: {
    image: './src/assets/img/star-win.svg',
    audioSrc: './src/assets/audio/success.mp3',
    finalImage: './src/assets/img/success.jpg',
    finalAudioSrc: './src/assets/audio/gta.mp3',
  },

  fail: {
    image: './src/assets/img/star.svg',
    audioSrc: './src/assets/audio/error.mp3',
    finalImage: './src/assets/img/failure.jpg',
    finalAudioSrc: './src/assets/audio/dun.mp3',
  },


};

export default sets;
